import { Check } from "lucide-react";

type StepperProps = {
  currentStep: number;
  totalSteps?: number;
};

export function Stepper({ currentStep, totalSteps = 3 }: StepperProps) {
  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);

  return (
    <div className="flex items-center justify-between md:mx-10 mx-2">
      {steps.map((step, index) => (
        <div
          key={step}
          className={`flex items-center ${
            index < steps.length - 1 ? " flex-1" : ""
          }`}
        >
          <div
            className={`w-8 h-8 bg-gray-200 text-n-primary border-2 border-gray-300 rounded-full flex items-center justify-center font-medium transition-colors ${
              step > currentStep ? "bg-transparent " : "bg-gray-200"
            } `}
          >
            {step < currentStep ? (
              <Check className="text-n-primary w-5 h-5" />
            ) : step > currentStep ? (
              <span className="text-gray-500">{step}</span>
            ) : (
              step
            )}
          </div>

          {index < steps.length - 1 && (
            <div className="flex-1 border-t border border-dashed border-gray-400 mx-1" />
          )}
        </div>
      ))}
    </div>
  );
}
